




document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("pincodePopup");
  const closeBtn = document.querySelector(".close-popup");
  const checkBtn = document.getElementById("checkPincodeBtn");
  const input = document.getElementById("pincodeInput");
  const message = document.getElementById("pincodeMessage");
  const locationSpan = document.getElementById("edt__location");
  const updateTrigger = document.getElementById("updatePincodeTrigger");
  const deliverrr = document.getElementById('deliverr');

  // ✅ Open popup
  function openPopup() {
    popup.style.display = "block";
    updateTrigger.style.display = "none";
    input.value = "";
    message.textContent = "";
    if( input.value !== ""){
      updateTrigger.style.display = "none";
    }
    else{
      deliverrr.style.display = "block";
    }
  }

  // ✅ Close popup
  function closePopup() {

    popup.style.display = "none";
    
    if( input.value === ""){
          // alert('ok');
      updateTrigger.style.display = "flex";
      deliverrr.style.display = "none";
    }else{
      deliverrr.style.display = "block";
    }
  }

  // ✅ Show saved pincode on load
  const savedPincode = localStorage.getItem("userPincode");
  if (savedPincode) {
    locationSpan.textContent = savedPincode;
    deliverrr.style.display = 'block';
    updateTrigger.style.display = "none";
  }

  // ✅ Open popup on click
  updateTrigger.addEventListener("click", openPopup);
   deliverrr.addEventListener("click", openPopup);

  // ✅ Close popup on ×
  closeBtn.addEventListener("click", closePopup);


  // ✅ Close popup when clicking outside
  window.addEventListener("click", (e) => {
    if (e.target === popup) closePopup();
  });
});




document.addEventListener("DOMContentLoaded", () => {
  const GIFT_WRAP_VARIANT_ID = 46982580437184; // Replace with your Gift Wrap variant ID

  // --- Get current cart ---
  async function getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  // --- Add gift wrap ---
  async function addGiftWrap(qty) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: qty }] }),
    });
  }

  // --- Remove gift wrap ---
  async function removeGiftWrap() {
    const cart = await getCart();
    const item = cart.items.find(i => i.variant_id == GIFT_WRAP_VARIANT_ID);
    if (item) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    }
  }

  // --- Calculate wraps ---
  function calculateWraps(totalProducts) {
    return Math.ceil(totalProducts / 4);
  }

  // --- Refresh cart page ---
  async function refreshCartPage() {
    try {
      // Fetch cart items
      const itemsRes = await fetch(`${routes.cart_url}?section_id=main-cart-items`);
      const itemsHTML = await itemsRes.text();
      const docItems = new DOMParser().parseFromString(itemsHTML, "text/html");

      const newCartItems = docItems.querySelector("cart-items");
      const currentCartItems = document.querySelector("cart-items");
      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }

      // Detect cart footer section dynamically
      const footerSection = document.querySelector('[id^="shopify-section-"][id$="cart-footer"]');
      const footerSectionId = footerSection?.id?.replace("shopify-section-", "");

      if (footerSectionId) {
        const footerRes = await fetch(`${routes.cart_url}?section_id=${footerSectionId}`);
        const footerHTML = await footerRes.text();
        const docFooter = new DOMParser().parseFromString(footerHTML, "text/html");

        const newFooter = docFooter.querySelector(`#shopify-section-${footerSectionId}`);
        if (newFooter && footerSection) {
          footerSection.outerHTML = newFooter.outerHTML;
        }
      }

      // Update cart count
      const cart = await getCart();
      const bubble_t = document.querySelector(".cart_bbl");
      if (bubble_t) bubble_t.textContent = cart.item_count;

      // ✅ Reattach event + restore checkbox state after footer refresh
      reattachGiftWrapCheckbox();

    } catch (error) {
      console.error("❌ refreshCartPage() failed:", error);
    }
  }

  // --- Main logic for gift wrap ---
  async function handleGiftWrapLogic(updateCart = false) {
    const cart = await getCart();
    const checkbox = document.querySelector("#giftWrapCheckbox");
    if (!checkbox) return;

    const wrapItem = cart.items.find(i => i.variant_id == GIFT_WRAP_VARIANT_ID);
    const totalItems = cart.items
      .filter(i => i.variant_id != GIFT_WRAP_VARIANT_ID)
      .reduce((sum, item) => sum + item.quantity, 0);

    const wrapsNeeded = calculateWraps(totalItems);

    if (checkbox.checked) {
      localStorage.setItem("giftWrapChecked", "true");

      if (!wrapItem || wrapItem.quantity !== wrapsNeeded) {
        await removeGiftWrap();
        if (wrapsNeeded > 0) await addGiftWrap(wrapsNeeded);
      }
    } else {
      localStorage.removeItem("giftWrapChecked");
      if (wrapItem) await removeGiftWrap();
    }

    if (updateCart) await refreshCartPage();
  }

  // --- Reattach checkbox logic after refresh ---
  function reattachGiftWrapCheckbox() {
    const checkbox = document.querySelector("#giftWrapCheckbox");
    if (!checkbox) return;

    // Restore state
    const savedState = localStorage.getItem("giftWrapChecked");
    checkbox.checked = savedState === "true";

    // Remove existing listeners before adding new one
    checkbox.replaceWith(checkbox.cloneNode(true));
    const newCheckbox = document.querySelector("#giftWrapCheckbox");

    newCheckbox.addEventListener("change", () => handleGiftWrapLogic(true));
  }

  // --- On load ---
  (async () => {
    reattachGiftWrapCheckbox();
    await handleGiftWrapLogic(false);
  })();
});

